import React from 'react'

import { StCredits } from './style.css'

const Credits = () => (
  <StCredits>
    <div className="creditsWrapper">
      <h2>Créditos</h2>

      <p className="font-sans m-0 p-0 ">
        <span>Idea y coordinación:</span>
      </p>
      <p className="font-sans m-0 mb-4 p-0 ">
        <strong>Tania Opazo</strong>
        <strong>Sebastián Rivas</strong>
      </p>

      <p className="font-sans m-0 p-0 ">
        <span>Data Scraping:</span>
      </p>
      <p className="font-sans m-0 mb-4 p-0 ">
        <strong>Víctor González</strong>
        <strong>Sebastián Leyton</strong>
      </p>

      <p className="font-sans m-0 p-0 ">
        <span>Diseño y Desarrollo:</span>
      </p>
      <p className="font-sans m-0 mb-4 p-0 ">
        <strong>Álex Acuña Viera</strong>
      </p>
      <p className="font-sans m-0 p-0 ">
        <span>Agradecimientos:</span>
      </p>
      <p className="font-sans m-0 mb-4 p-0 ">
        <strong> Gonzalo Díaz</strong>
        <strong> Jorge Negrete</strong>
        <strong> Christopher Concha</strong>
      </p>
    </div>
  </StCredits>
)

export default Credits
